import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, tool, commonData } from "@/mixins/index";
import api from '@/api';
export default {
  name: "gatewayOrder",
  mixins: [loadMoreList, tool, commonData],
  data: function data() {
    return {
      datePicker: [],
      pagingReqFn: "gateOrderList",
      orderStatus: [{
        label: "创建",
        value: 1
      }, {
        label: "回调处理中",
        value: 2
      }, {
        label: "回调处理成功",
        value: 3
      }, {
        label: "回调处理失败",
        value: 4
      }],
      //订单状态
      deliverStatues: [{
        label: "默认创建",
        value: 1
      }, {
        label: "开始回调研发",
        value: 2
      }, {
        label: "回调研发成功",
        value: 3
      }, {
        label: "回调研发失败",
        value: 4
      }, {
        label: "回调次数超过允许值",
        value: 5
      }],
      // 分发状态
      dateTypeKey: 'month',
      paramsData: {
        isMustAppid: 1,
        third_part_pay_type: ''
      },
      payData: []
    };
  },
  created: function created() {
    this.getTodayRange(this.dateType);
  },
  activated: function activated() {
    this.getcommonData(['appListAllData', 'appPaymentTypeAllData']);
  },
  methods: {
    // getWayList(){
    //   this.$api.appListAllData({...this.paramsData,appid: this.paramsData.toString()}).then(res=>{
    //     if(res.status == 200){
    //       this.appListAllData = res.data  
    //     }
    //   })
    // },
    payTypeChange: function payTypeChange(e) {
      if (e.length) {
        this.paramsData.third_part_pay_type = e.join(",");
      } else {
        this.paramsData.third_part_pay_type = '';
      }
    },
    exportDataFn: function exportDataFn() {
      var _this = this;

      api[this.pagingReqFn](_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page: 1,
        page_size: this.total + 10
      })).then(function (res) {
        if (res.status == 200) {
          var columns = [{
            label: '应用名称',
            prop: 'appName'
          }, {
            label: '网关用户ID',
            prop: 'gate_user_id'
          }, {
            label: '游戏研发用户ID',
            prop: 'developer_user_id'
          }, {
            label: 'gate_sdk订单ID',
            prop: 'gate_order_id'
          }, {
            label: '订单ID',
            prop: 'pay_order_id'
          }, {
            label: '研发订单号',
            prop: 'developer_order_id'
          }, {
            label: '设备ID',
            prop: 'device_id'
          }, {
            label: '支付平台类型',
            prop: 'third_part_pay_type'
          }, {
            label: '支付平台订单号',
            prop: 'third_part_order_id'
          }, {
            label: '服务器ID',
            prop: 'server_id'
          }, {
            label: '登录用户ID',
            prop: 'login_user_id'
          }, {
            label: '商品',
            prop: 'product'
          }, {
            label: '商品名称',
            prop: 'product_name'
          }, {
            label: '商品描述',
            prop: 'product_desc'
          }, {
            label: '商品价格(元)',
            prop: 'price'
          }, {
            label: '货币类型',
            prop: 'currency'
          }, {
            label: '订单状态',
            prop: 'order_status'
          }, {
            label: '分发状态',
            prop: 'deliver_status'
          }, {
            label: '分发次数',
            prop: 'deliver_times'
          }, {
            label: '订单创建时间',
            prop: 'create_time'
          }, {
            label: '订单被回调时间',
            prop: 'callback_time'
          }, {
            label: '订单最新分发时间',
            prop: 'deliver_time'
          }, {
            label: '成功处理时间',
            prop: 'success_time'
          }];
          var data = res.data.data;
          data.forEach(function (item) {
            item.price = _this.$utils.conversion(item.price);
            item.order_status = item.order_status ? _this.orderStatus.find(function (i) {
              return i.value == item.order_status;
            }).label : '/';
            item.deliver_status = item.deliver_status ? _this.deliverStatues.find(function (i) {
              return i.value == item.deliver_status;
            }).label : '/';
            item.create_time = item.create_time ? _this.$times.timestampToTime(item.create_time) : '/';
            item.callback_time = item.callback_time ? _this.$times.timestampToTime(item.callback_time) : '/';
            item.deliver_time = item.deliver_time ? _this.$times.timestampToTime(item.deliver_time) : '/';
            item.success_time = item.success_time ? _this.$times.timestampToTime(item.success_time) : '/';
          });

          _this.$export.excel({
            columns: columns,
            data: data,
            title: _this.$route.meta.title
          });
        }
      });
    }
  }
};